<template>
  <div class="p-5">
    <h3 class="m-0">Challenges</h3>
    <p class="no-content w-50">
      Challenges will be included in the next release of Goalpilot.
      You will be able to start exciting challenges, for the things you always wanted to do,
      like learning a new language or training for your first 10K.
      You can even create your own challenges and invite your friends to join you.
    </p>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";

export default {
  name: "ChallengeCatalogPage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
